import styled from "styled-components";
import colors from "../../../../../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  box-sizing: border-box;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  width: 670px;
  height: 100%;
  background: transparent;
  padding-left: 40px;
  @media (max-width: 1400px) {
    width: 435px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  padding-left: 10px;
  box-sizing: border-box;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  height: 100%;
  cursor: pointer;
  border-left: 2px solid ${colors.orange1};
  @media (max-width: 1366px) {
    width: 435px;
  }
`;
